/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import axios from "axios";
import Swal from "sweetalert2";
import "./usuarios_style.css";
import "@github/relative-time-element";
import { FaEdit, FaUserLock } from "react-icons/fa";
import { MdOutlineClose } from "react-icons/md";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import { json } from "react-router-dom";

function Usuarios({ updatePermisos }) {
  const [users, setUsers] = useState([]);
  const [updateMenu, setUpdateMenu] = useState(false);
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [usersPerPage, setUsersPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");

  const filteredUsers = searchValue
    ? users.filter(
        (user) =>
          user.first_name.toUpperCase().includes(searchValue.toUpperCase()) ||
          user.last_name.toUpperCase().includes(searchValue.toUpperCase()) ||
          user.email.toUpperCase().includes(searchValue.toUpperCase())
      )
    : users;

  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;

  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPageCount = Math.ceil(filteredUsers.length / usersPerPage);
  const pageNumbers = [];
  const maxPageNumbersToShow = 20;

  let startPage, endPage;
  if (totalPageCount <= maxPageNumbersToShow) {
    startPage = 1;
    endPage = totalPageCount;
  } else {
    startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    endPage = Math.min(totalPageCount, startPage + maxPageNumbersToShow - 1);

    if (endPage - startPage < maxPageNumbersToShow) {
      startPage = endPage - maxPageNumbersToShow + 1;
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const showEntries = (e) => {
    setUsersPerPage(e.target.value);
  };

  const handleSearch = () => {
    const input = document.getElementById("searchInput");
    setSearchValue(input.value.trim());
  };

  const deleteUser = async (id) => {
    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "Seguro que desea eliminar este registro?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminarlo",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
      });

      if (result.isConfirmed) {
        await axios.delete(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/users/delete/${id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
            },
          }
        );

        Swal.fire("¡Eliminado!", "El usuario ha sido eliminado.", "success");
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "No se realizo ninguna accion", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  const updateUser = async (id) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/users/${id}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        const user = res.data.data[0];
        const reactComponentHtml = ReactDOMServer.renderToString(
          <div className="card-body">
            <div className="row">
              <div className="col-sm-12">
                <form
                  className="form-horizontal fv-form fv-form-bootstrap"
                  acceptCharset="UTF-8"
                  id="formValidation"
                  encType="multipart/form-data"
                  noValidate="novalidate"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                >
                  <div className="rootwizard">
                    <br />
                    <div className="tab-content">
                      <div className="tab-pane fade show active" id="tab1">
                        <div className="form-group row mb-3 ">
                          <label
                            className="col-sm-2 control-label text-black"
                            htmlFor="first_name"
                          >
                            Nombre <span style={{ color: "#fa0073" }}>*</span>
                          </label>
                          <div v className="col-sm-10">
                            <input
                              id="first_name"
                              className="form-control"
                              placeholder="Nombre"
                              name="first_name"
                              type="text"
                              data-fv-field="first_name"
                              value={user.first_name}
                            />
                          </div>
                        </div>
                        <div className="form-group row mb-3 ">
                          <label
                            className="col-sm-2 control-label text-black"
                            htmlFor="last_name"
                          >
                            Apellido <span style={{ color: "#fa0073" }}>*</span>
                          </label>
                          <div v className="col-sm-10">
                            <input
                              id="last_name"
                              className="form-control"
                              placeholder="Apellido"
                              name="last_name"
                              type="text"
                              data-fv-field="last_name"
                              value={user.last_name}
                            />
                          </div>
                        </div>
                        <div className="form-group row mb-3 ">
                          <label
                            className="col-sm-2 control-label text-black"
                            htmlFor="email"
                          >
                            Correo Electrónico{" "}
                            <span style={{ color: "#fa0073" }}>*</span>
                          </label>
                          <div v className="col-sm-10">
                            <input
                              id="email"
                              className="form-control"
                              placeholder="example@correo.com"
                              name="email"
                              type="text"
                              data-fv-field="email"
                              value={user.email}
                            />
                          </div>
                        </div>
                        <div className="form-group row mb-3 ">
                          <label
                            className="col-sm-2 control-label text-black"
                            htmlFor="password"
                          >
                            Contraseña{" "}
                            <span style={{ color: "#fa0073" }}>*</span>
                          </label>
                          <div v className="col-sm-10">
                            <input
                              id="password"
                              className="form-control"
                              placeholder="Contraseña"
                              name="password"
                              type="password"
                              data-fv-field="password"
                            />

                            <small
                              className="help-block-edit"
                              data-fv-validator="notEmpty"
                              data-fv-for="password"
                              data-fv-result="INVALID"
                            >
                              Deja este campo vacio si no deseas cambiar la
                              Contraseña
                            </small>
                          </div>
                        </div>
                        <div className="form-group row mb-3 ">
                          <label
                            className="col-sm-2 control-label text-black"
                            htmlFor="password_confirm"
                          >
                            Confirmacion de la Contraseña{" "}
                            <span style={{ color: "#fa0073" }}>*</span>
                          </label>
                          <div v className="col-sm-10">
                            <input
                              id="password_confirm"
                              className="form-control"
                              placeholder="Confirmacion de la Contraseña"
                              name="password_confirm"
                              type="password"
                              data-fv-field="password_confirm"
                            />

                            <small
                              className="help-block-edit"
                              data-fv-validator="notEmpty"
                              data-fv-for="password"
                              data-fv-result="INVALID"
                            >
                              Deja este campo vacio si no deseas cambiar la
                              Contraseña
                            </small>
                          </div>
                        </div>
                        <div className="form-group row mb-3 ">
                          <label
                            className="col-sm-2 control-label text-black"
                            htmlFor="role_id"
                          >
                            Permisos <span style={{ color: "#fa0073" }}>*</span>
                          </label>
                          <div v className="col-sm-10">
                            <select
                              className="form-control"
                              name="role_id"
                              data-fv-field="role_id"
                              id="role_id"
                            >
                              <option selected="selected" value="selected">
                                Permisos
                              </option>
                              <option value="1" selected={user.role_id === 1}>
                                Administrador
                              </option>
                              <option value="2" selected={user.role_id === 2}>
                                Usuario
                              </option>
                              <option value="3" selected={user.role_id === 3}>
                                Tarifa
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        );
        let nameInput;
        let last_nameInput;
        let emailInput;
        let passwordInput;
        let confrimPasswowrdInput;
        let permissionsInput;

        const result = await Swal.fire({
          title: "Actualizar usuario",
          html: reactComponentHtml,
          showDenyButton: true,
          confirmButtonText: "Actualizar",
          denyButtonText: "Cancelar",
          width: 1000,
          padding: "1px",
          color: "#716add",
          backdrop: `
        rgba(0,0,0,0.8)
      `,
          customClass: {
            confirmButton: "btn-amc-blue",
            denyButton: "btn-cancel",
            title: "alert-title",
            popup: "alert-bg",
          },
          focusConfirm: false,
          didOpen: async () => {
            const popup = Swal.getPopup();
            nameInput = popup.querySelector("#first_name");
            last_nameInput = popup.querySelector("#last_name");
            emailInput = popup.querySelector("#email");
            passwordInput = popup.querySelector("#password");
            confrimPasswowrdInput = popup.querySelector("#password_confirm");
            permissionsInput = popup.querySelector("#role_id");

            // ⛔️ Evitar que Enter confirme el SweetAlert
            popup.addEventListener("keydown", (e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            });
          },
          preConfirm: async () => {
            const name = nameInput.value;
            const lastName = last_nameInput.value;
            const email = emailInput.value;
            const password = passwordInput.value;
            const confirmPassword = confrimPasswowrdInput.value;
            const permissions = permissionsInput.value;

            // Validación de campos
            if (!name || !lastName || !email || !permissions) {
              Swal.showValidationMessage(`Todos los campos son requeridos`);
              return false;
            }

            // Validación del nombre
            if (
              !/^[a-zA-ZáéíóúÁÉÍÓÚüÜñÑ\s]+$/.test(name) ||
              name.length < 3 ||
              name.length > 50
            ) {
              Swal.showValidationMessage(`Ingresa un nombre válido`);
              return false;
            }

            // Validación del apellido
            if (
              !/^[a-zA-ZáéíóúÁÉÍÓÚüÜñÑ\s]+$/.test(lastName) ||
              lastName.length < 3 ||
              lastName.length > 50
            ) {
              Swal.showValidationMessage(`Ingresa un apellido válido`);
              return false;
            }

            // Validación del email
            if (
              !/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(email)
            ) {
              Swal.showValidationMessage(
                `Por favor introduce un correo electrónico válido`
              );
              return false;
            }

            if (password.length < 0) {
              // Validación de la contraseña
              if (password.length < 6 || password.length > 16) {
                Swal.showValidationMessage(
                  `La contraseña debe tener entre 6 y 16 caracteres`
                );
                return false;
              }

              if (password !== confirmPassword) {
                Swal.showValidationMessage(`Las contraseñas no coinciden`);
                return false;
              }
            }

            // Validación de permisos
            if (permissions === "selected") {
              Swal.showValidationMessage(`Selecciona un permiso válido`);
              return false;
            }

            const data = {
              first_name: name,
              last_name: lastName,
              email: email,
              password: password.length === 0 ? user.password : password,
              role_id: permissions,
            };

            const updateResponse = await axios.put(
              `${process.env.REACT_APP_URL_BACKEND}/api/v1/users/update/${id}`,
              data,
              {
                headers: {
                  Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
                },
              }
            );

            if (updateResponse.data.code === 1) {
              Swal.fire(
                "Actualizado!",
                "El usuario ha sido actualizado.",
                "success"
              );
              setUpdateTrigger(!updateTrigger);
            } else {
              throw Error(updateResponse);
            }

            return true;
          },
        });

        // Si el usuario cancela, result.dismiss contendrá el valor "cancel"
        if (result.dismiss === "cancel") {
          Swal.fire("Cancelado", "No se realizo ninguna accion", "error");
        }
      }
    } catch (error) {
      console.error(error);
      if (error.response && error.response.data) {
        if (error.response.data.message === "Unique Constraint Error") {
          Swal.fire("Error", "el email ya esta registrado", "warning");
        }
      } else {
        Swal.fire("Error", "Hubo un error", "error");
      }
    }
  };

  const updatePersmissos = async (id) => {
    let permissions;
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/permissions/${id}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        permissions = res.data.data;
      } else {
        Swal.fire("Error", "Hubo un error", "error");
      }
      const reactComponentHtml = ReactDOMServer.renderToString(
        <div className="card-body">
          <div className="row">
            <div className="col-sm-12">
              <form
                className="form-horizontal fv-form fv-form-bootstrap"
                acceptCharset="UTF-8"
                id="formValidation"
                encType="multipart/form-data"
                noValidate="novalidate"
              >
                <table
                  className="table table-inverse table-hover table-striped table-bordered dataTable no-footer"
                  role="grid"
                  aria-describedby="datatables_info"
                >
                  <thead>
                    <tr role="row">
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="datatables"
                        rowSpan={1}
                        colSpan={1}
                        style={{ width: "81.2031px" }}
                      >
                        Módulos
                      </th>
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="datatables"
                        rowSpan={1}
                        colSpan={1}
                        style={{ width: "178.203px" }}
                      >
                        Sin Acceso
                      </th>
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="datatables"
                        rowSpan={1}
                        colSpan={1}
                        style={{ width: "180.766px" }}
                      >
                        Con Acceso
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {permissions.map((permission) => (
                      <tr key={permission.id}>
                        <td>{permission.name}</td>
                        <td>
                          <input
                            type="radio"
                            name={`access-${permission.id}`}
                            id={`noAccess-${permission.id}`}
                            value={false}
                            defaultChecked={permission.access === false}
                          />
                        </td>
                        <td>
                          <input
                            type="radio"
                            name={`access-${permission.id}`}
                            id={`withAccess-${permission.id}`}
                            value={true}
                            defaultChecked={permission.access === true}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </form>
            </div>
          </div>
        </div>
      );

      const updatePermission = async (userId, permissionId, accessValue) => {
        try {
          const res = await axios.post(
            `${process.env.REACT_APP_URL_BACKEND}/api/v1/permissions/update`,
            {
              id_user: userId,
              id_permiso: permissionId,
              permission: accessValue,
            },
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`,
              },
            }
          );
          if (res.data.code === 1) {
            console.log("Actualizado");
          }
        } catch (error) {
          console.error(error);
        }
      };

      const result = await Swal.fire({
        title: "Actualizar Permisos",
        html: reactComponentHtml,
        width: 1000,
        padding: "1px",
        color: "#716add",
        backdrop: `
          rgba(0,0,0,0.8)
        `,
        customClass: {
          cancelButton: "btn-cancel",
          title: "alert-title",
          popup: "alert-bg",
        },
        didOpen: async () => {
          permissions.forEach((permission) => {
            document
              .getElementById(`noAccess-${permission.id}`)
              .addEventListener("change", (event) => {
                if (event.target.checked) {
                  updatePermission(id, permission.id, false);
                }
              });
            document
              .getElementById(`withAccess-${permission.id}`)
              .addEventListener("change", (event) => {
                if (event.target.checked) {
                  updatePermission(id, permission.id, true);
                }
              });
          });
        },
        preConfirm: async () => {
          setUpdateMenu(!updateMenu);
        },
      });

      if (result.dismiss === "cancel") {
        setUpdateMenu(!updateMenu);
      }
    } catch (error) {}
  };

  const getUsers = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/users`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        const sorted = res.data.data.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        setUsers(sorted);
        setLoading(false);
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  const getPersmission = async (id) => {
    try {
      const updatedRes = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/permissions/${id}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (updatedRes.data.code === 1) {
        updatePermisos(updatedRes.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    // Extraer los componentes de la fecha y la hora
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    // Formatear la fecha y la hora en el formato deseado
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedDate;
  };

  useEffect(() => {
    getUsers();
  }, [updateTrigger]);

  useEffect(() => {
    const userJSON = localStorage.getItem("user");
    if (userJSON) {
      const user = JSON.parse(userJSON);
      getPersmission(user.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateMenu]);

  return (
    <>
      <ScrollToTop />
      <div className="table-responsive">
        <div
          className="dataTables_wrapper dt-bootstrap4 no-footer"
          id="datatables_wrapper"
        >
          <div className="row justify-content-between mb-2">
            <div className="col-sm-12 col-md-4">
              <div className="dataTables_length" id="dataTables_length">
                <label className="d-flex justify-content-end">
                  <span className="mr-2 p-2">Mostrar</span>
                  <select
                    name="datatables_length"
                    aria-controls="datatables_length"
                    className="custom-select custom-select-sm form-control-sm narrow-select p-2"
                    onChange={showEntries}
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <span className="ml-2 p-2">Registros</span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 col-md-4">
              <div className="datatables_filter" id="datatables_filter">
                <label className="d-flex justify-content-end">
                  <span className="mr-2 mt1 p-2">Buscar</span>
                  <input
                    type="search"
                    id="searchInput"
                    className="form-control form-control-sm"
                    placeholder
                    aria-controls="datatables"
                  />
                  <button className="btn-amc-blue ml-2" onClick={handleSearch}>
                    Buscar
                  </button>
                </label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <table
                className="table table-inverse table-hover table-striped table-bordered dataTable no-footer"
                role="grid"
                aria-describedby="datatables_info"
              >
                <thead>
                  <tr role="row">
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "81.2031px" }}
                    >
                      ID
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "178.203px" }}
                    >
                      Nombre
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "180.766px" }}
                    >
                      Apellido
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "343.25px" }}
                    >
                      Correo Electrónico
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "159.453px" }}
                    >
                      Creado
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "159.453px" }}
                    >
                      Ultima sesion
                    </th>
                    <th
                      className="sorting_disabled"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "161.125px" }}
                    >
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentUsers.map((user) => (
                    <tr key={user.id}>
                      <td>{user.id}</td>
                      <td>{user.first_name}</td>
                      <td>{user.last_name}</td>
                      <td>{user.email}</td>
                      <td>
                        <relative-time
                          datetime={formatDate(user.created_at)}
                          lang="es"
                        />
                      </td>
                      <td>
                        <relative-time
                          datetime={formatDate(user.last_login)}
                          lang="es"
                        />
                      </td>
                      <td>
                        <FaEdit
                          className="btn-edit"
                          onClick={() => {
                            updateUser(user.id);
                          }}
                        />
                        <MdOutlineClose
                          className="btn-delete"
                          onClick={() => {
                            deleteUser(user.id);
                          }}
                        />
                        <FaUserLock
                          className="btn-permissos"
                          onClick={() => {
                            updatePersmissos(user.id);
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="row">
            <nav aria-label="Page navigation example">
              <ul className="pagination">
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Anterior
                  </button>
                </li>
                {pageNumbers.map((pageNumber) => (
                  <li
                    className={`page-item ${
                      pageNumber === currentPage ? "active" : ""
                    }`}
                    key={pageNumber}
                  >
                    <button
                      className="page-link"
                      onClick={() => paginate(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                ))}
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === totalPageCount}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}

export default Usuarios;
